import { oppositionEvent, homeEvent, ownGoal } from './constants';

/**
 * It's a home team event if the fixture is played at home, and the event is for us
 * Or if the fixture is played away, and for the opposition. If the event is an own goal, we invert the logic to ensure
 * the event is logged for the goal awarded team.
 * @param event
 * @returns {boolean}
 */
export function isHomeTeamEvent(event) {
  if (event.eventType.toLowerCase() === ownGoal && event.type === oppositionEvent) {
    return true;
  }

  if (event.eventType.toLowerCase() === ownGoal && event.type === homeEvent) {
    return false;
  }

  return event.type === homeEvent;
}

/**
 * Returns the player name for the event, or a default if not available. If the event is an own goal, we append (OG)
 *
 * @param event
 * @returns {string|string|*}
 */
export function eventPlayerName(event) {
  if (event.eventType.toLowerCase() === 'own goal') {
    return event.playerName ? `${event.playerName} (OG)` : 'Player (OG)';
  }
  return event.playerName || 'Player';
}
